module.exports = __webpack_public_path__ + "static/media/img1.296a4249.jpg";